import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsReadthedocsComponent } from './simple-icons-readthedocs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsReadthedocsComponent ],
    exports:      [ SimpleIconsReadthedocsComponent ],
    bootstrap:    []
})
export class SimpleIconsReadthedocsModule {}
